import { Switch } from "@sagot/ui";
import { useId } from "react";

interface SwitchRowProps {
  label: string;
  description?: string;
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

/** A setting with a title, a line of help and an on / off switch. */
export function SwitchRow({ label, description, checked, disabled, onChange }: SwitchRowProps) {
  const id = useId();
  return (
    <div className="flex items-start justify-between gap-4 rounded-lg border border-line p-4">
      <div>
        <p id={`${id}-label`} className="text-sm font-semibold">{label}</p>
        {description ? <p id={`${id}-description`} className="text-xs text-fg-subtle">{description}</p> : null}
      </div>
      <Switch checked={checked} disabled={disabled} onCheckedChange={onChange} aria-labelledby={`${id}-label`} aria-describedby={description ? `${id}-description` : undefined} />
    </div>
  );
}
